import { createFileRoute } from '@tanstack/react-router'

import { HealthInsuranceBeneficiariesPage } from '../../../../../components/pages/health-insurance/beneficiaries-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/(customer)/_portal/health-insurance/beneficiaries')({
  component: () => (
    <PermissionChecker requiredPermissions={['contract.read']}>
      <HealthInsuranceBeneficiariesPage />
    </PermissionChecker>
  ),
})
